import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import Co2Footprints from 'components/desktop/_general/Co2Footprint/Co2Footprints';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import ENTITLEMENTS from 'enums/entitlements';
import { usePermissions } from 'hooks/usePermissions';

const TabCo2Footprints = ({ state, handlers }: BaseIngredientTabProps) => {
	const { isBaseIngredientEditor } = usePermissions();

	return (
		<RenderIf entitlements={[ENTITLEMENTS.CARBONDIOXIDE]}>
			<Co2Footprints
				disabled={!isBaseIngredientEditor}
				characteristic={state.characteristic}
				footprints={state.co2Footprints}
				setFootprints={handlers.setCo2Footprints}
			/>
		</RenderIf>
	);
};

export default TabCo2Footprints;
